import React from 'react'
import "../css/estilos.css"
const Precios = () => {
  return (
    <>
      <div className="grilla">

      <div className="card">
    <div className="poster">
      <img src="https://images.pexels.com/photos/4458554/pexels-photo-4458554.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="asd" />"
    </div>
    <div className="details">
    
     <br></br>
    
      <div className="tags">
        <span className="fantasy">Todos los Niveles</span>
        <a href="https://wa.link/qwnf6w"><span className="mystery">S/ 310.00</span></a>
      </div>
      <div className="info">
        <li>📹 Grabación de Clases</li>
        <li>🧑🏼‍🎓 10 clases Individuales</li>
        <li>🖥️Plataforma-Zoom Video Call</li>
        <li>📚 Material de Estudio</li>
        <li>💬 Wsp English Friends</li>
        <li>📝 Evaluación constante</li>

      </div>
      <div className="tags">
        <a href="https://wa.link/qwnf6w"><span className="fantasy">Contactar</span></a>
      </div>
    </div>
  </div>

  <div className="card">
    <div className="poster">
      <img src="https://images.pexels.com/photos/4458554/pexels-photo-4458554.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="asd" />"
    </div>
    <div className="details">
    
     <br></br>
    
      <div className="tags">
        <span className="fantasy">Inglés Medico</span>
        <a href="https://wa.link/qwnf6w"><span className="mystery">S/350.00</span></a>
      </div>
      <div className="info">
        <li>📹 Grabación de Clases</li>
        <li>🧑🏼‍🎓 10 clases Individuales</li>
        <li>🖥️Plataforma-Zoom Video Call</li>
        <li>📚 Material de Estudio</li>
        <li>💬 Wsp English Friends</li>
        <li>📝 Evaluación constante</li>

      </div>
      <div className="tags">
        <a href="https://wa.link/qwnf6w"><span className="fantasy">Contactar</span></a>
      </div>
    </div>
  </div>


  <div className="card">
    <div className="poster">
      <img src="https://images.pexels.com/photos/4458554/pexels-photo-4458554.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="asd" />"
    </div>
    <div className="details">
    
     <br></br>
    
      <div className="tags">
        <span className="fantasy">Asesoramiento Ingles</span>
        <a href="https://wa.link/qwnf6w"><span className="mystery">S/30.00</span></a>
      </div>
      <div className="info">
        <li>📹 Grabación de Clases</li>
        <li>🧑🏼‍🎓 1 clase Individuale</li>
        <li>🖥️Plataforma-Zoom Video Call</li>
        <li>📚 Material de Estudio</li>
        <li>💬 Wsp English Friends</li>
        <li>📝 Evaluación constante</li>

      </div>
      <div className="tags">
        <a href="https://wa.link/qwnf6w"><span className="fantasy">Contactar</span></a>
      </div>
    </div>
  </div>

  <div className="card">
    <div className="poster">
      <img src="https://images.pexels.com/photos/4458554/pexels-photo-4458554.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="asd" />"
    </div>
    <div className="details">
    
     <br></br>
    
      <div className="tags">
        <span className="fantasy">Preparación Cambridge</span>
        <a href="https://wa.link/qwnf6w"><span className="mystery">S/33.00</span></a>
      </div>
      <div className="info">
        <li>📹 Grabación de Clases</li>
        <li>🧑🏼‍🎓 1 clase Individuales</li>
        <li>🖥️Plataforma-Zoom Video Call</li>
        <li>📚 Material de Estudio</li>
        <li>💬 Wsp English Friends</li>
        <li>📝 Evaluación constante</li>

      </div>
      <div className="tags">
        <a href="https://wa.link/qwnf6w"><span className="fantasy">Contactar</span></a>
      </div>
    </div>
  </div>



     
     </div>





     
        

        
    </>
  )
}

export default Precios
